module.exports = __webpack_public_path__ + "media/categories/25v-d28efc4c.svg";